import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const today = new Date();
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

// Format dates as YYYY-MM-DD strings
const formatDateToString = (date: Date) => {
  console.log("getting default date");
  const c = date.toISOString().split("T")[0];
  return c;
};

export const Route = createFileRoute("/admindashboard/_layout/")({
  validateSearch: z.object({
    start: z.string().date().default(formatDateToString(firstDayOfMonth)),
    end: z.string().date().default(formatDateToString(today)),
    status: z.enum(["TAUGHT", "NOT_TAUGHT"]).optional(),
    services: z.array(z.number().int()).optional(),
  }),
});
